export default __webpack_public_path__ + "static/media/rectangulo-marron.5e023145.svg";